import { Injectable } from '@angular/core';
import { Command } from '../command/command';
import { CommandHandler } from '../command/command-handler';
import { State } from '../state';
import { AppState } from '../state.module';

import {
  AddCurrentWizzardStep,
  AddKaskoIdCommand,
  AddInitInfoCommand,
  AddPhoneInfoCommand,
  AddKaskoCustomerTypeCommand,
  AddKaskoCustomerIdCommand,
  AddKaskoPaymentIdCommand
} from './kasko-commands';

@Injectable()
export class KaskoCommandHandlerService implements CommandHandler {

  handle(state: State, command: Command): State {
    const appState = (state as AppState);

    switch (command.name) {
      case 'add_current_wizzard_step_kasko':
        const addCurrentWizzardStep = (command as AddCurrentWizzardStep);
        return appState.kasko.addCurrentWizzardStep(addCurrentWizzardStep.step);

      case 'add_kasko_id':
        const addKaskoIdCommand = (command as AddKaskoIdCommand);
        return appState.kasko.addKaskoId(addKaskoIdCommand.id);

      case 'add_init_info_kasko':
        const addInitInfoCommand = (command as AddInitInfoCommand);
        return appState.kasko.addInitInfo(addInitInfoCommand.brand, addInitInfoCommand.model, addInitInfoCommand.purchasePhoneAmount);

      case 'add_phone_info_kasko':
        const addPhoneInfoCommand = (command as AddPhoneInfoCommand);
        return appState.kasko.addPhoneInfo(addPhoneInfoCommand.imei, addPhoneInfoCommand.imgReceiptUrl, addPhoneInfoCommand.note, addPhoneInfoCommand.purchaseDate);

      case 'add_customer_type_kasko':
        const addKaskoCustomerTypeCommand = (command as AddKaskoCustomerTypeCommand);
        return appState.kasko.addKaskoCustomerType(addKaskoCustomerTypeCommand.type);
      case 'add_customer_id_kasko':
        const addKaskoCustomerIdCommand = (command as AddKaskoCustomerIdCommand);
        return appState.kasko.addKaskoCustomerId(addKaskoCustomerIdCommand.id);
      case 'add_payment_id_kasko':
        const addKaskoPaymentIdCommand = (command as AddKaskoPaymentIdCommand);
        return appState.kasko.AddKaskoPaymentId(addKaskoPaymentIdCommand.id);
    }

    throw new Error(`KaskoCommandHandlerService cannot handle command ${command.name}".`);
  }
}



// WEBPACK FOOTER //
// ./src/app/state/kasko/kasko-command-handler.service.ts